import * as React from "react";
import styles from "./Input.module.css";
import { cn } from "../../../utils/cn";
import { EyeClosedIcon, EyeIcon } from "lucide-react";

const Input = ({
  className,
  type = "text",
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) => {
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const isPasswordType = type === "password";
  const inputType = isPasswordType
    ? isPasswordVisible
      ? "text"
      : "password"
    : type;

  return (
    <div className={cn(styles.inputWrapper, className)}>
      <input
        type={inputType}
        className={cn(styles.input, isPasswordType && styles.toggle)}
        {...props}
      />
      {isPasswordType && (
        <button
          className={styles.toggleVisibility}
          onClick={togglePasswordVisibility}
          onMouseDown={(e) => e.preventDefault()}
          type="button"
          aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          aria-controls={props.id}
        >
          {isPasswordVisible ? (
            <EyeClosedIcon size={18} />
          ) : (
            <EyeIcon size={18} />
          )}
        </button>
      )}
    </div>
  );
};

export { Input };
